const Form104EN = {
    stepName: {
        importantNotes: "Important Notes",
        partA: "School Basic Information",
        partB: "School Background Information",
        partC: "Declaration",
        confirmation: "Confirmation",
    },

    importantNotesContent: {
        statement:
            "I have read, understood and agreed to the above terms and conditions.",
        termsConditions:
            'I understand the applicant need to have an "iAM Smart+" account to process the application.',
    },
    note: {
        partB: "[<i>The school supervisor please <b><u>confirm and provide</u></b> school information as at <b><u>{{snapshot}}</u></b> and <b><u>declare in Part C</u></b> that the contents are true and correct. The Education Bureau does not guarantee accuracy of the information and accepts no liability for any loss or damage arising from any inaccuracy or omission.</i>]",
        schoolEmail:
            "Please provide an email address as an electronic contact means for this Bureau to facilitate further communication with the School on this School Information Form.",
        certificateNote1:
            "Five subjects at Grade E or level 2 or above in the Hong Kong Certificate of Education Examination , including English Language [English Language (Syllabus B) before 2007] or Chinese Language in no more than two sittings.",
        certificateNote2:
            "Five subjects in the Hong Kong Diploma of Secondary Education Examination, including Level 2 in English Language or Chinese Language and any combination of the following:",
        certificateNote3: "Level 2 in New Senior Secondary subjects;",
        certificateNote4:
            "“Attained” in Applied Learning subjects (subject to a maximum of two Applied Learning subjects); and",
        certificateNote5: "Grade E in Other Language subjects",
        certificateNote6: "in no more than two sittings.",
    },

    label: {
        scrn: "School Number",
        schoolNumber: "School Number",
        principalOrSupervisor: "Your position in the school",
        district: "District",
        schoolName: "School Name",
        registeredSchoolPremises: "Registered School Premises",
        schoolEmail: "School E-mail address",
        schoolTelephone: "School Telephone number",
        schoolFax: "School Fax number",
        schoolWebsite: "School website",
        supervisorTitle: "Title of supervisor",
        supervisorSurname: "Surname of supervisor",
        supervisorGivenName: "Given name of supervisor",
        principalTitle: "Title of principal",
        principalSurname: "Surname of principal",
        principalGivenName: "Given name of principal",
        schoolFacilities:
            "School facilities (e.g. computer room, library other than registered classrooms)",
        teacherInformation: "Teacher information",
        fulltimeTeachers: "(i) Number of full-time teachers",
        parttimeTeachers: "(ii) Number of part-time teachers",
        teachersHighestQualifications:
            "(iii) Highest qualifications attained by teachers",
        qualifications: "Qualifications",
        postgraduateDegrees: "Postgraduate<br>degrees",
        bachelorDegrees: "Bachelor<br>degrees",
        diplomasOrCertificates: "Post-secondary<br>diplomas/certificates",
        certificateText1:
            "Certificate(s) of Hong Kong Certificate of Education Examination <span style='font-size: 12px'>Note (1)</span>",
        certificateText2: "or",
        certificateText3:
            "Hong Kong Diploma of Secondary Education Examination <span style='font-size: 12px'>Note (2)</span>",
        grandTotal: "Grand Total",
        trainedTeachersNo:
            "No. of trained teachers (with diploma/ certificate/ degree in education or teacher’s certificate)",
        untrainedTeachersNo: "No. of untrained teachers",
        teacherInformationRemark:
            "Remarks : The total number for (a)+(b) should be the same as that for (c)+(d).",
        insurancePolicy:
            "Insurance Policy as at {{insurancePolicyStartDate}} (e.g. Public liability)",
        insuranceType: "Type of Insurance",
        insuranceCompany: "Insurance Company",
        policyNumber: "Policy Number",
        expiryDate: "Expiry Date",
        declaration: "Declaration",
        schoolInformationCheck1:
            "I certify that all contents of this form are true and correct, and I *",
        schoolInformationCheck2:
            " to having the above school information (except the name of the supervisor and the name of the principal) uploaded to the Education Bureau Homepage for public reference.",
        supervisorPersonalParticularsCheck1: "I *",
        supervisorPersonalParticularsCheck2:
            " to disclose the name of the supervisor on the Education Bureau Homepage for public reference.",
        principalPersonalParticularsCheck1: "I *",
        principalPersonalParticularsCheck2:
            " to disclose the name of the principal on the Education Bureau Homepage for public reference.",
        schoolChop: "School Chop",
        filledBySchoolHead: "Filled by Principal",
        filledBySchoolSupervisor: "Filled by School Supervisor",
        appliantRole: "The role of applicant",
        schoolHeadApplicationStatus:
            "Has the Bureau approved the application for principal appointment?",
        supervisorApplicationStatus:
            "Has the Bureau approved you as the school supervisor?",
        notProvided: "Not provided",
        note: "Note",
    },
    errorMsg: {
        totalNumberSame:
            "The total number for (a)+(b) should be the same as that for (c)+(d).",
        expiryDate: "policy expired.",
        fulltimeTeachers: "Please input “0” if there is no full-time teachers.",
        parttimeTeachers: "Please input “0” if there is no part-time teachers.",
        schoolNumber:
            "It is not a valid school number of a private school offering a non-formal curriculum.",
        appliantRole: "Please select the role to return.",
        alreadySubmitted:
            "The school has already submitted the application for this year.",
        consistentName: "Surname and given name should be in same language.",
        tel: "Please do not enter the same phone number.",
        required: "This field is required.",
        maxTextLength: "This field must be at most {{max}} characters.",
        validWithName: "Please input a valid {{fieldName}}.",
        faxRule: "Please input a valid fax number.",
        telRule: "Please input a valid telephone number.",
        accessRequiredFile: "Please upload {{fieldName}}.",
        number: {
            max: "The maximum value of this field is {{max}}.",
            integer: "This field must be an integer.",
        },
        text: {
            invalid: "Please input a valid {{fieldName}}.",
        },
        email: {
            rule: "Please input a valid email address.",
        },
    },
    option: {
        principalOrSupervisor: {
            principal: "School Principal",
            supervisor: "School Supervisor",
            principalAndSupervisor: "School Principal and School Supervisor",
        },
        supervisorApplicationStatus: {
            approved: "application approved",
            inProcess: "application in process",
        },
        principalApplicationStatus: {
            approved: "application approved",
            inProcess: "application in process",
            exempted: "appointment exempted",
        },
        title: {
            Mr: "Mr.",
            Ms: "Ms.",
            Miss: "Miss.",
            Br: "Br.",
            Dr: "Dr.",
            Fr: "Fr.",
            Rev: "Rev.",
            Sr: "Sr.",
            Ven: "Ven.",
        },
        declaration: {
            yes: "agree",
            no: "do not agree",
        },
    },
    dialog: {
        title: "Note",
        content:
            "Please print and manually sign on the completed form.  The signed form should be sent to the School Registration and Compliance Section of the Education Bureau by post (office address: Room 2810, 28/F, E-trade Plaza, 24 Lee Chung Street, Chai Wan, Hong Kong), by fax (Fax Number: 2123 1276) or by email (cct@edb.gov.hk).",
    },
    signature: {
        applicant:
            "This form is signed and submitted by <b>{{name}} {{post}}</b>.",
        approver:
            "This form is signed and submitted by <b>{{name}} {{post}}</b>.",
        secApprover:
            "This form is signed and submitted by <b>{{name}} {{post}}</b>.",
        reviewer:
            "This form is accepted and signed by <b>{{name}} {{post}}</b>.",
    },
    mode: {
        edbEdit:
            "Notice: This form is pending for being accepted by EDB officer.",
    },
    button: {
        edbSubmit: "Accept",
    },
    reply: {
        haveReturnReminder:
            "Do you want to return to the applicant with a reminder message?",
    },
};
export default Form104EN;
